import { tv } from 'tailwind-variants'

export const CarouselHorizontalStyles = tv({
  slots: {
    root: 'relative flex w-full flex-col items-center gap-10 overflow-hidden pl-8 pt-6 pb-6 py-10 text-white sm:px-10 lg:flex-row lg:items-stretch lg:px-10 lg:py-16',
    headerContainer: 'flex w-full pr-8 flex-col items-center md:items-start gap-6 lg:w-1/3', // Corrigido de lg:w-/5 para 1/3
    title: 'typo-h1 text-center md:text-left text-neutral-6',
    button: 'text-foundation-laranja',
    navContainer: 'hidden md:flex gap-3 pt-11',
    navButton:
      'w-8 h-8 bg-neutral-6 rounded-full flex items-center justify-center shrink-0 transition-opacity disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer',
    navIcon: 'text-foundation-laranja',
    carouselContainer: 'w-full lg:w-2/3',
    card: '!w-[282px] h-[348px]',
    swiper: '!w-[282px]',
    ghostSlide: 'pointer-events-none! opacity-0!'
  }
})
